import {
  TempAmbient20Px,
  TempChilled20Px,
  TempFrozen20Px
} from "@qubit/autoparts";

import { TemperatureZone as WarehouseTemperatureZone } from "~/types/api";

export type TempZone = "ambient" | "chilled" | "frozen";

/** Fallback when the grid's temperature zones are temporarily unknown. */
export const allTemperatureZones: WarehouseTemperatureZone[] = [
  "Ambient",
  "Chilled",
  "Frozen"
];

const tempZoneToTemperatureZoneMap: Record<TempZone, WarehouseTemperatureZone> =
  {
    ambient: "Ambient",
    chilled: "Chilled",
    frozen: "Frozen"
  };

export function tempZoneToTemperatureZone(
  tempZone: TempZone
): WarehouseTemperatureZone {
  return tempZoneToTemperatureZoneMap[tempZone];
}

export const temperatureZoneColors: Record<TempZone, string> = {
  ambient: "ambient.main",
  chilled: "chilled.main",
  frozen: "frozen.main"
};

export const tempZoneIconMap: Record<
  TempZone,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  ambient: TempAmbient20Px,
  chilled: TempChilled20Px,
  frozen: TempFrozen20Px
};

export const tempZoneBasedColor = (tempZone: string) => {
  const tempZoneToLowerCase = tempZone.toLowerCase();
  switch (tempZoneToLowerCase) {
    case "ambient":
      return temperatureZoneColors.ambient;
    case "chilled":
      return temperatureZoneColors.chilled;
    case "frozen":
      return temperatureZoneColors.frozen;
    default:
      return temperatureZoneColors.ambient;
  }
};

/**
 * Normalizes temperature zone strings to a known zone or null.
 */
export function parseProductTempZone(
  value: string | null | undefined
): TempZone | null {
  if (!value) {
    return null;
  }

  const normalized = value.trim().toLowerCase();
  if (
    normalized === "ambient" ||
    normalized === "chilled" ||
    normalized === "frozen"
  ) {
    return normalized;
  }

  return null;
}
